namespace GeniuzPOS.AdvPromo {
    export class Adv05ItemDetailColumns {
        static columnsKey = 'AdvPromo.Adv05ItemDetail';
    }
}
